import * as React from 'react';
import {
  Typography,
  Grid,
  CircularProgress,
  Stack,
  styled,
  Paper,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { fetchLinktivityPreview } from '../../../common/api/linktivities';
import StandardsDisplay from './StandardsDisplay';
import ProductPics from './ProductPics';

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export default function LtvPreview(props) {
  const { id } = props;
  const [singleLinkivity, setSingleLinkivity] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchLinktivityPreview(id)
      .then((res) => {
        const previewLinktivity = res.data;
        if (previewLinktivity.demo_video_link) {
          previewLinktivity.demo_video_link =
            previewLinktivity.demo_video_link.replace(
              'youtu.be',
              'www.youtube.com/embed'
            );
        }
        setSingleLinkivity(previewLinktivity);
      })
      .catch((err) => {
        console.error(err);
        setSingleLinkivity({});
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <>
      {loading ? (
        <Grid container spacing={10}>
          <Grid item xs={12}>
            <CircularProgress color='secondary' />
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography textAlign={'left'}>
              {singleLinkivity.linktivity_description}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography textAlign={'left'} variant='h6'>
              See this LINKtivity® in action here!
            </Typography>
          </Grid>
          <Grid item md={1}></Grid>
          <Grid item xs={12} md={10}>
            <ProductPics
              demoVideoLink={singleLinkivity.demo_video_link}
              linktivityName={singleLinkivity.linktivity_name}
              picURLs={singleLinkivity.product_pics}
            ></ProductPics>
          </Grid>
          <Grid item md={1}></Grid>
          <Grid item xs={12}>
            <Stack
              direction='column'
              alignItems='flex-start'
              justifyContent='flex-start'
              spacing={1}
              style={{ height: '100%' }}
            >
              <Item elevation={0} square>
                <Typography variant='h5'>Standards Covered</Typography>
              </Item>
              {singleLinkivity.attached_standards &&
              singleLinkivity.attached_standards.length > 0 ? (
                <Item elevation={0} square>
                  <StandardsDisplay
                    standards={singleLinkivity.attached_standards}
                  />
                </Item>
              ) : (
                <Item elevation={0} square>
                  <Typography variant='body2' textAlign={'left'}>
                    This LINKtivity is not aligned with any specific standards.
                  </Typography>
                </Item>
              )}
            </Stack>
          </Grid>
        </Grid>
      )}
    </>
  );
}
